import { render, staticRenderFns } from "./CourseChapter.vue?vue&type=template&id=2bf62e4a&scoped=true"
import script from "./CourseChapter.vue?vue&type=script&lang=js"
export * from "./CourseChapter.vue?vue&type=script&lang=js"
import style0 from "./CourseChapter.vue?vue&type=style&index=0&id=2bf62e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf62e4a",
  null
  
)

export default component.exports